import { axios } from "../../utils/axios";
import configurationConstants from "./configurationConstants";
const configurationAPI = {};

configurationAPI.getLocationList = async (id) => {
  let jsonData;
  try {
    var res = await axios.get(
      configurationConstants.GET_LOCATIONS.replace(":ID", id),
    );
    jsonData = res?.data;
  } catch (e) {
    jsonData = {};
  }
  return jsonData;
};

configurationAPI.getClientList = async (id) => {
  let jsonData;
  try {
    var res = await axios.get(
      configurationConstants.GET_CLIENTS.replace(":ID", id),
    );
    jsonData = res?.data;
  } catch (e) {
    jsonData = {};
  }
  return jsonData;
};

configurationAPI.getConfiguration = async (id, locID) => {
  let jsonData;
  try {
    var res = await axios.get(
      `${configurationConstants.GET_CONFIGURATION}/${id}/${locID}`,
    );
    jsonData = res?.data;
  } catch (e) {
    jsonData = {};
  }
  return jsonData;
};

configurationAPI.submitConfigurationForm = async (data) => {
  let jsonData;
  try {
    var res = await axios.post(configurationConstants.SAVE_CONFIGURATION, data);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

configurationAPI.submitLocationConfiguration = async (data) => {
  // console.log("id",data);
  let jsonData;
  try {
    var res = await axios.post(
      configurationConstants.SAVE_LOCATION.replace(":ID", data.client_id),
      data,
    );
    jsonData = res;
  } catch (e) {
    // console.log("e.respone",e.response);
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

configurationAPI.submitChartListSettings = async (data, userId) => {
  let jsonData;
  try {
    var res = await axios.post(
      configurationConstants.SAVE_CHART_LIST_SETTINGS.replace(":ID", userId),
      data,
    );
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

configurationAPI.updateDesignationsForParticularRole = async ({roleId, reqBody}) => {
  let jsonData;
  try {
    let res = await axios.post(
      `users/roles/${roleId}/designations`,
      reqBody
    );
    jsonData = res;
  } catch (e) {
    if (e?.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.addAuditArea = async ({ data, clientId, locationId}) => {
  let jsonData;
  try {
    var res = await axios.post(`${configurationConstants.ADD_AUDIT_AREA}/${clientId}/${locationId}`, data);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
};

configurationAPI.getAuditAreas = async ({clientId = 0, locationId = 0}) => {
  let jsonData;
  try {
    var res = await axios.get(`${configurationConstants.ADD_AUDIT_AREA}/${clientId}/${locationId}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.getNewAuditInfo = async (id) => {
  let jsonData;
  try {
    var res = await axios.get(`v2/charts/${id}/audit-info`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.updateFeedbackCategoryDropdowns = async (data) => {
  let jsonData;
  try {
    var res = await axios.post(`${configurationConstants.ADD_AUDIT_AREA}/dropdowns`, data);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.deleteFeedbackCategory = async (id) => {
  let jsonData;
  try {
    var res = await axios.delete(`${configurationConstants.ADD_AUDIT_AREA}/${id}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.addChartInfoCustomFields = async (data, clientId, locationId) => {
  let jsonData;
  try {
    var res = await axios.post(`${configurationConstants.CHART_INFO_FIELDS}/${clientId}/${locationId}`, data);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.updateChartInfoCustomFields = async (data, clientId, locationId) => {
  let jsonData;
  try {
    var res = await axios.put(`${configurationConstants.CHART_INFO_FIELDS}/${clientId}/${locationId}`, data);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.deleteChartInfoCustomField = async (id) => {
  let jsonData;
  try {
    var res = await axios.delete(`${configurationConstants.CHART_INFO_FIELDS}/${id}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.getChartInfoCustomFields = async (clientId, locationId) => {
  let jsonData;
  try {
    var res = await axios.get(`${configurationConstants.CHART_INFO_FIELDS}/${clientId}/${locationId}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.addHCCFields = async (data) => {
  let jsonData;
  try {
    var res = await axios.post(`${configurationConstants.HCC_FIELDS}`, data);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.updateHCCFields = async (data) => {
  let jsonData;
  try {
    var res = await axios.put(`${configurationConstants.HCC_FIELDS}`, data);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.deleteHCCField = async (id) => {
  let jsonData;
  try {
    var res = await axios.delete(`${configurationConstants.HCC_FIELDS}/${id}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.getHCCFields = async () => {
  let jsonData;
  try {
    var res = await axios.get(`${configurationConstants.HCC_FIELDS}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.getDefaultFeedbackCategories = async () => {
  let jsonData;
  try {
    var res = await axios.get(`${configurationConstants.DEFAULT_FEEDBACK_CATEGORIES}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

configurationAPI.getFeedbackCategoriesCopy = async ({clientId, locationId, categoryKey}) => {
  let jsonData;
  try {
    var res = await axios.get(`${configurationConstants.FEEDBACK_CATEGORY_COPY}/${clientId}/${locationId}/${categoryKey}`);
    jsonData = res;
  } catch (e) {
    if (e.response) {
      jsonData = e.response.data;
    } else {
      jsonData = {};
    }
  }
  return jsonData;
}

export default configurationAPI;
